export default __webpack_public_path__ + "static/media/okara-logo-footer.0813c4c6.png";